import InboxModel from './Inbox/InboxModel';
import UserModel from './UserModel';

const userStore = UserModel.create({
  id: '',
  createdAt: new Date(),
  lat: '',
  lng: '',
  isEmailVerified: false,
  isOnboarded: false,
  appInstalled: false,
  profilePhoto: '',
  firstName: 'You',
  email: 'you@you.you',
});

const inboxStore = InboxModel.create({
  approved: [],
  unreadCount: 0,
  currentUser: userStore,
});

export default {
  inboxStore,
  userStore,
};



// WEBPACK FOOTER //
// ./src/mobxStores/index.js